<div *ngIf="displayIdl" class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
  
        <!-- Header -->
        <div class="modal-header">
          <h5 class="modal-title">
            Periodo de reporte 
          </h5>
          <button type="button" class="btn-close" (click)="closeReport()"></button>
        </div>
  
        <!-- Body -->
        <div class="modal-body">
  
          <p class="text-muted" *ngIf="mensaje && caracterizacionComercializador.tamanoComercializador !== null">
            {{ mensaje }}
          </p>
          <p class="text-muted" *ngIf="caracterizacionComercializador.tamanoComercializador === null">
            Se requiere seleccionar el tamaño del comercializador
          </p>
  
          <div class="row g-3">
  
           <app-periodo-mensual
             [years]="years"
             [months]="months"
             [minDate]="minDate"
             [(selectedYear)]="selectedYear"
             [(selectedMonth)]="selectedMonth"
             *ngIf="caracterizacionComercializador.tamanoComercializador === 'Grande'"
           ></app-periodo-mensual>

           <app-periodo-trimestral
             [years]="years"
             [quarters]="quarters"
             [minDate]="minDate"
             [(selectedYear)]="selectedYear"
             [(selectedQuarter)]="selectedQuarter"
             *ngIf="caracterizacionComercializador.tamanoComercializador === 'Mediano'"
           ></app-periodo-trimestral>
           
           <app-periodo-semestral
             [years]="years"
             [semesters]="semesters"
             [minDate]="minDate"
             [(selectedYear)]="selectedYear"
             [(selectedSemester)]="selectedSemester"
             *ngIf="caracterizacionComercializador.tamanoComercializador === 'Pequeño'"
           ></app-periodo-semestral>


  
            <!-- Errores -->
            <div *ngIf="errorMessages.length > 0" class="col-12">
              <div class="alert alert-danger mb-0">
                <p class="mb-0" *ngFor="let error of errorMessages">
                  {{ error }}
                </p>
              </div>
            </div>
  
          </div>
  
        </div>
  
        <!-- Footer -->
        <div class="modal-footer">
          <app-button
            label="Cancelar"
            variant="danger"
            (clicked)="closeReport()">
          </app-button>

          <app-button
            [label]="labelBotonConfirmar"
            variant="success"
            (clicked)="submit()"
            *ngIf="mensaje && caracterizacionComercializador.tamanoComercializador !== null">
          </app-button>
        </div>
  
      </div>
    </div>
  </div>
  
  <!-- Backdrop manual -->
  <div *ngIf="displayIdl" class="modal-backdrop fade show"></div>

  <!-- Confirmación reemplazo (misma idea que modal-ventas) -->
  <div *ngIf="displayIdlConfirm">
    <div class="swal2-container swal2-center swal2-backdrop-show">
      <div
        class="swal2-popup swal2-modal swal2-show centrar"
        tabindex="-1"
        role="dialog"
        aria-live="assertive"
        aria-modal="true"
        style="display: flex">
        <div class="swal2-header view_conteiner-alert">
          <button type="button" class="view_btn-close" (click)="volverConfirm()">
            <i class="fas fa-times"></i>
          </button>
          <h2
            class="swal2-title titlre-confirm"
            id="swal2-title-confirm"
            style="display: flex">
            {{ mensajeConfirm }}
          </h2>
          <div class="conteinerbts-confirm">
            <button
              type="button"
              class="view_btn-alert"
              (click)="continuar()">
              Continuar
            </button>
            <button
              type="button"
              class="view_btn-alert"
              (click)="volverConfirm()">
              {{ nombreBtnVolver }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>